import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useCurrentUserHasSeenNotificationNudgeModal_session$key } from "./__generated__/useCurrentUserHasSeenNotificationNudgeModal_session.graphql";

export const useCurrentUserHasSeenNotificationNudgeModal = (
  sessionRef: useCurrentUserHasSeenNotificationNudgeModal_session$key | null
) => {
  const session = useFragment(
    useCurrentUserHasSeenNotificationNudgeModalFragmentString,
    sessionRef
  );
  return !!session?.currentClientProfile?.member?.user?.metadata
    ?.hasSeenNotificationNudgeModal;
};

const useCurrentUserHasSeenNotificationNudgeModalFragmentString = graphql`
  fragment useCurrentUserHasSeenNotificationNudgeModal_session on Session {
    currentClientProfile {
      member {
        ... on Member {
          user {
            metadata {
              hasSeenNotificationNudgeModal
            }
          }
        }
        ... on Customer {
          user {
            metadata {
              hasSeenNotificationNudgeModal
            }
          }
        }
      }
    }
  }
`;
